import { IAccount } from 'store/accounts.model';
import { IApiResponse } from 'utils/models';

export type IFormValues = {
  serviceName: string;
  invoice: string;
  invoiceDescription: string;
  createdDate: string;
  expiryDate: string;
  invoiceStatus: string;
  customerName: string;
  narration: string;
  sourceAccount: string;
  amount: string;
};

export interface IGetAgencyResponse extends IApiResponse {
  bills: IAgency[];
}

export interface IGetInvoiceResponse extends IApiResponse {
  invoice: IInvoiceData;
}

export interface IAgency {
  name: string;
  code: string;
}

export interface IGhanaPaymentsState {
  serviceName: IServiceName[];
  invoice: string;
  accounts: IAccount[];
  currency: string;
}

export interface IInvoiceData {
  createdDate: string;
  customerName: string;
  expiryDate: string;
  invoiceDescription: string;
  invoiceNumber: string;
  invoiceStatus: string;
  narration: string;
  totalAmount: string;
  totalAmountCurrency: string;
}

export enum Steps {
  VERIFY = 'VERIFY',
  PROCEED = 'PROCEED',
}

export interface IPayInvoice {
  invoiceNumber: string;
  amount: string;
  currency: string;
  passwordType: string;
  password: string;
  channel: string;
  transType: string;
  sourceAccount: string;
  serviceName: string;
  expiryDate: string;
}

export interface IServiceName {
  id: number;
  name: string;
  code: string;
  serviceFields: IServiceField[];
}

export interface IServiceField {
  id: number;
  displayName: string;
  fieldName: string;
  serviceType: {
    id: number,
    code: string,
    name: string,
  }
}

export interface ITaxTypes {
  id: number;
  name: string;
  serviceType: {
    id: number,
    code: string,
    name: string,
  };
}

export interface IServiceResponse extends IApiResponse {
  serviceTypes: IServiceName[];
}

export interface ITaxTypesResponse extends IApiResponse {
  taxTypes: ITaxTypes[];
}

export interface ICreateInvoiceResponse extends IApiResponse {
  amount: string;
  currency: string;
  expiry: string;
  invoiceNumber: string;
  name: string;
  remarks: string;
  tin: string;
}
